import { render } from "./NavbarProjectPrice.vue?vue&type=template&id=6353bbe7&scoped=true"
import script from "./NavbarProjectPrice.vue?vue&type=script&lang=js"
export * from "./NavbarProjectPrice.vue?vue&type=script&lang=js"

import "./NavbarProjectPrice.vue?vue&type=style&index=0&id=6353bbe7&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6353bbe7"]])

export default __exports__